"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORKDAYS = void 0;
exports.NETWORKDAYS = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:NETWORKDAYS not implemented');
    },
};
//# sourceMappingURL=networkdays.js.map